import React,{useState} from "react";
import axios from "axios";
import Results from "./Results";
import "./Dictionary.css";
import Photos from "./Photos";

export default function Dictionary(){
    let [keyword, setKeyword] = useState("sunset");
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null);

    function handleResponse(response){
        console.log(response.data[0]);
        console.log(response.data[0].meanings[0].definitions[0].definition);
        setResults(response.data[0]);
    }
    function handlePexelsResponse(response){
        console.log(response.data)
        setPhotos(response.data.photos);
    }

    function search(){
        // documentation: https://dictionaryapi.dev/
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        //console.log(apiUrl);
        axios.get(apiUrl).then(handleResponse);

        let pexelsApiKey ="jyMqBUlKPAm1xrvGcWFeiR9f7sSAiINDAN2qBUvBYmpA5ExZnOrGDUr9"
        let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
        axios
        .get(pexelsApiUrl, {
          headers: {
            Authorization: `${pexelsApiKey}`,
          },
        })
        .then(handlePexelsResponse);

    }

    function handleSubmit(event){
        event.preventDefault();
        search();
    }
 

    function handleKeywordChange(event){
        setKeyword(event.target.value);
        
    }

    function load(){
        setLoaded(true);
        search();
    }

    if(loaded){
        return (<div className="Dictionary">
            <section>
                <h1>What word do you want to look up?</h1>
            <form  onSubmit = {handleSubmit} >
                <input type="search" autoFocus={true} onChange={handleKeywordChange} defaultValue="sunset"/>
            </form>
            <div className="hint">suggested words: sunset, wine, yoga ...</div>
            </section>
            <Results results={results}/>
            <Photos photos={photos} />
        </div>);
     }else{
        load();
        return "Loading...";
     }

}
